import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/opt/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/src/components/category/filters/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/src/components/category/header/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/src/components/category/product-wrapper.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/src/components/ui/breadcrumb/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/src/components/ui/next-image/index.js");
